import { useEffect } from 'react';

import { IPaginationParams, IPaginationResponse } from '@/interfaces/pagination';

import { useWindowScrollReachedEnd } from './useWindowScrollReachedEnd';

interface IPagination<T = any> {
  isFetching: boolean;
  onReachedEnd: (params: IPaginationParams) => void;
  data?: IPaginationResponse<T, IPaginationParams>;
}

export const useRefetchWhenReachEnd = <T>({ isFetching, data, onReachedEnd }: IPagination<T>) => {
  const reachedEnd = useWindowScrollReachedEnd();

  useEffect(() => {
    if (!data || isFetching || !reachedEnd) return;

    if (data.total_pages > data.page.page) {
      onReachedEnd({
        ...data.page,
        page: (data?.page.page ?? 0) + 1
      });
    }
  }, [reachedEnd, data, isFetching, onReachedEnd]);
};
